import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { ApiModelStrategy } from 'src/app/services/rest-api/rest-api';

@Component({
  selector: 'libero-model-strategy-card',
  templateUrl: './model-strategy-card.component.html',
  styleUrls: ['./model-strategy-card.component.scss'],
  standalone: false
})
export class ModelStrategyCardComponent {
  @Input() public modelStrategy!: ApiModelStrategy;

  public constructor(
    private router: Router,
  ) { }

  public routeToNewModelStrategy(): void {
    this.router.navigate(['/strategy/new/' + this.modelStrategy.modelStrategyId]);
  }
}
